(function(){
    if (typeof choix_images !== "undefined" && choix_images !== null) {
        var p_fond = "";
        var p_drape = "";
        var p_toge = "";
        if (typeof premiers_choix !== "undefined" && premiers_choix !== null) {
            p_fond = premiers_choix['fond'];
            p_drape = premiers_choix['drape'];
            p_toge = premiers_choix['toge'];
        }

        var img_non_disp = "/wp-content/plugins/alain-choix/images/non-disponible.jpg";
        if (typeof choix_path_images !== "undefined" && choix_path_images !== null) {
            img_non_disp = choix_path_images['txt'] + "non-disponible.jpg";
        }

        new Vue({
            el: "#choix_de_decor",
            data: {
                choix_fond: p_fond,
                choix_drape: p_drape,
                choix_toge: p_toge,
                choix_epitoge: "",
                choix_images: choix_images,
                images_epitoges: choix_epitoges,
                img_non_disp: img_non_disp,
                show_loader: false,
                choix_tab: "fond",
                previous_choix_epitoge: "",
                epitoge_img_display: "block"
            },
            computed: {
                choix_img: function() {
                    var choix = this.choix_toge + "_" + this.choix_fond + "-" + this.choix_drape;

                    if (choix in this.choix_images) {
                        return this.choix_images[choix];
                    } else {
                        return this.img_non_disp;
                    }
                },
                loader_display: function() {
                    return this.show_loader ? "flex" : "none";
                },
                choix_epitoge_img: function() {
                    if (typeof this.images_epitoges[this.choix_epitoge] !== "undefined" && this.images_epitoges[this.choix_epitoge] !== null) {
                        return this.images_epitoges[this.choix_epitoge];
                    } else {
                        return "";
                    }
                },
                epitoge_display: function() {
                    return this.choix_epitoge_img === "" ? "none" : "block";
                }
            },
            watch: {
                choix_img: function(new_src, old_src) {
                    if (new_src !== old_src) {
                        this.show_loader = true;
                    }
                },
                choix_epitoge_img: function(new_src, old_src) {
                    if (new_src !== old_src && new_src !== "") {
                        this.show_loader = true;
                    }
                }
            },
            methods: {
                choix_loaded: function() {
                    this.show_loader = false;
                },
                epitoge_check: function(value) {
                    if (value === this.previous_choix_epitoge) {
                        this.choix_epitoge = "";
                        this.previous_choix_epitoge = "";
                    } else {
                        this.choix_epitoge = value;
                        this.previous_choix_epitoge = value;
                    }
                }
            }
        });
    }
}());
